export default "/_next/static/c7d7727c60e8f1af76ae21aa2cbf3e2b.png";